import { useState, useEffect } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-grid.css";

export default function AgGridTable({ 
    columns, perPage = 10, rowData = [], onCellClicked = () => {}
}) {

    const [gridApi, setGridApi] = useState(null);
    const onGridReady = (params) => {
        setGridApi(params.api);
    }

    useEffect(() => {
        if (gridApi) {
            const dataSource = {
                getRows: (params) => {
                    params.successCallback(rowData, rowData.length);
                }
            }
            gridApi.setDatasource(dataSource);
        }
    }, [gridApi, rowData])

    return (
        <div
            aria-live="polite"
            aria-busy={false}
            className="ag-theme-material"
        >
            <AgGridReact
                columnDefs={columns}
                pagination={true}
                rowModelType="infinite"
                paginationPageSize={perPage}
                cacheBlockSize={perPage}
                onGridReady={onGridReady}
                domLayout="autoHeight"
                defaultColDef={{
                    resizable: true,
                    flex: 1
                }}
                onCellClicked={onCellClicked}
            />
        </div>
    )
}